import {Component, Input, OnInit, Output, EventEmitter, DoCheck, ViewChild, Inject, OnChanges} from '@angular/core';
import {ConfirmTestcaseDeletionComponent} from '../testsuite/testsuite.component';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {QueryBuilderConfig} from 'angular2-query-builder';
import {LeftpanelComponent} from '../leftpanel/leftpanel.component';
import exportFromJSON from 'export-from-json';
import {ConfService} from '../conf.service';
import {ConnecttocrudService} from '../connecttocrud.service';
import {ConnectorsService} from '../connectors.service';
import {GetConnectorConfigurationsComponent} from '../settings/connectors/connectors.component';
import {AddAttributeComponent} from '../query-builder/query-builder.component';
import {TestCaseNameInputDialog} from '../testcase/testcase.component';

@Component({
    selector: 'app-data-transformation-plan',
    templateUrl: './data-transformation-plan.component.html',
    styleUrls: ['./data-transformation-plan.component.scss']
})
export class DataTransformationPlanComponent implements OnInit, DoCheck, OnChanges {

    selectedTab = 0;
    @Input() dbs: any = [];
    @Input() apiProviders: any = [];
    @Input() plan: any = {};
    @Input() planIndex: any = 0;
    @Output() parentEvent = new EventEmitter<any>();
    @ViewChild('aceEditor') editor;
    @Input() editFlag = false;
    @Input() viewPlan = false;

    apiSearchText: any = '';
    sourceResponseAttributes: any = [];
    database: any;
    projectionAttributeList = [];
    table: any;
    target_table: any;
    file: any = {};
    csvHeaders: any;
    s3URL: any;
    fileUploadLoading = false;
    method: any = '';
    methodOption = [{'displayName': 'SQL Query', value: 'SQL Query'}, {'displayName': 'Query Builder', value: 'Query Builder'}];
    database_object_option = ['Tables', 'Indexes', 'Views', 'Synonyms', 'Stored Procedures', 'Users and Roles'];
    sourceOptions: any = ['Database', 'API', 'CSV'];
    targetOptions: any = ['Database', 'API'];
    selectedSource: any = 'Database';
    targetMappingTypes = [{value: 'sourceAttribute', displayName: 'Source Attribute'}, {
        value: 'static',
        displayName: 'Static Value'
    }, {value: '', displayName: 'Override Value'}, {value: 'condition', displayName: 'Conditional Mapping'}, {
        value: 'js',
        displayName: 'Javascript'
    }, {
        value: 'api',
        displayName: 'API'
    }];
    targetMappingValueTypes = [
        {
            displayName: 'String',
            value: 'text'
        },
        {
            displayName: 'Number',
            value: 'number'
        }
    ];
    tables: any = [];
    currentTableIndex = 0;
    currentTableName = '';
    Index = 0;
    sourceIndex = 0;
    sourceExtenderIndex = 0;
    code = '';
    @Input() enableEditor = true;
    selectedBQTab: any = 0;
    query1 = {
        condition: 'and',
        rules: [
            /*{field: 'age', operator: '=', value: ''}*/
        ]
    };
    query2 = {
        condition: 'and',
        rules: []
    };
    config1: QueryBuilderConfig;
    config2: QueryBuilderConfig;
    targetAttributesList = [];
    operationTypes = [
        {
            displayName: 'Insert',
            value: 'INSERT'
        },
        // {
        //   displayName: 'Update',
        //   value: 'UPDATE'
        // },
        // {
        //   displayName: 'Delete',
        //   value: 'DELETE'
        // }
    ];
    responseCode: any;
    responseData: any;
    responseError: any;
    responseTime: any;
    userView = 'json';
    searchText: any;
    filterData: any[];
    itemList: any[];
    settings = {text: 'Select attribute(s) to search instantly'};
    theme = 'vs-dark';
    options = {
        theme: this.theme,
        language: 'sql',
        automaticLayout: true
    };
    error = false;
    columns: string[] = [];
    itemLength: any;
    responseItems: any;
    responses: any;
    erroResponse: any;
    errorMessage: string;

    executors: any = [];
    targetExecutors: any = [];
    targetExecutorsList: any = [];

    executorsData: any;
    targetExecutorsData: any;
    targetExecutorsDataList: any;

    flag = false;
    target_flag = false;

    arrayList: any = [];
    targetArrayList: any = [];

    selected_executor: any;
    target_selected_executor: any;

    connections: any;
    targetConnections: any;
    targetConnectionsList: any = [];

    connectorsID: number;
    targetConnectorsID: number;
    targetConnectorsIDList: any = [];
    dataTypeFilter = 'mongodb';
    selectDatabase = 'default';

    targetName = '';
    currentTargetName = '';
    currentSourceName = '';
    currentSourceExtenderName = '';
    currentTargetIndex = 0;
    currentSourceIndex = 0;
    currentSourceExtenderIndex = 0;
    currentTarget = {};
    currentSource = {};
    isSidebarCollapsed: boolean = false;
    isSidebarCollapsed1: boolean = false;
    currentSourceExtender = {};
    isExecutorCollapsed = true;
    isExtenderExecutorCollapsed = true;
    isPaginationCollapsed = true;
    isTargetExecutorCollapsed = true;
    isDependentTargetExecutorCollapsed = true;
    isBatchStrategyCollapsed = true;
    isDependentBatchStrategyCollapsed = true;
    isDependentTargetCollapsed = true;
    editableIndex: number | null = null;
    editingName: string = '';

    paginationMethods = [
        {value: 'offset', viewValue: 'Offset-Based'},
        {value: 'apicursor', viewValue: 'API Cursor-Based'},
        {value: 'pagelimit', viewValue: 'Page-Based'},
        {value: 'time', viewValue: 'Time-Based'},
        {value: 'seek', viewValue: 'Seek (After-ID)'}
    ];

    defaultFieldOptions = {
        offset: {offsetField: 'offset', limitField: 'limit'},
        apicursor: {offsetField: 'page[after]', limitField: 'page[size]'},
        page: {offsetField: 'page', limitField: 'per_page'},
        time: {offsetField: 'start_time', limitField: 'end_time'},
        seek: {offsetField: 'after_id', limitField: 'limit'}
    };

    chunkStrategy = {
        paginationMethod: '',
        paginationFields: {
            offsetField: '',
            limitField: ''
        }
    };

    constructor(public dialog: MatDialog, private connectorsService: ConnectorsService, public platform: LeftpanelComponent, private confPost: ConfService, private _service: ConnecttocrudService) {
        this.config1 = {
            fields: {}
        };
        this.config2 = {
            fields: {}
        };
    }

    enableEdit(index: number) {
        this.editableIndex = index;
    }

    saveEdit(index: number, event: FocusEvent) {
        const element = event.target as HTMLElement;
        const newValue = (element.textContent || '').trim();

        if (newValue) {
            this.plan.target[index].name = newValue;
        }

        this.editableIndex = null;
    }

    onEnter(event: KeyboardEvent) {
        event.preventDefault(); // prevent newline
        (event.target as HTMLElement).blur(); // trigger blur/save
    }

    toggleExecutorCollapse() {
        this.isExecutorCollapsed = !this.isExecutorCollapsed;
    }

    toggleExtenderExecutorCollapse() {
        this.isExtenderExecutorCollapsed = !this.isExtenderExecutorCollapsed;
    }

    togglePaginationCollapse() {
        this.isPaginationCollapsed = !this.isPaginationCollapsed;
    }

    toggleBatchStrategyCollapse() {
        this.isBatchStrategyCollapsed = !this.isBatchStrategyCollapsed;
    }

    toggleDependentBatchStrategyCollapse() {
        this.isDependentBatchStrategyCollapsed = !this.isDependentBatchStrategyCollapsed;
    }

    toggledDependentTargetCollapse() {
        this.isDependentTargetCollapsed = !this.isDependentTargetCollapsed;
    }

    toggleTargetExecutorCollapse() {
        this.isTargetExecutorCollapsed = !this.isTargetExecutorCollapsed;
    }

    toggleDependentTargetExecutorCollapse() {
        this.isDependentTargetExecutorCollapsed = !this.isDependentTargetExecutorCollapsed;
    }

    ngOnInit() {
    }

    ngOnChanges() {
        // console.log(this.plan);
        // console.log(this.apiProviders);
    }

    ngDoCheck() {
        this.emitResult();
    }

    tabChanged(event) {
        this.selectedTab = event.index;
    }

    addDataTarget() {
        const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
            width: '400px',
            data: {name: '', type: 'target'}
        });
        dialogRef.afterClosed().subscribe(name => {
            if (name && name !== '' && name !== ' ') {
                const duplicatePlans = this.plan.target.filter((v, i) => v.name === name);
                if (!duplicatePlans.length) {
                    const obj = {
                        name: name,
                        target_type: 'API',
                        targetProvider: {},
                        targetExecutor: {method: '', apiUrl: '', params: {}},
                        targetConnector: {},
                        process_type_into_target: 'json',
                        sourceUniqueIdentifier: 'id',
                        fieldMappings: [
                            {
                                targetfield: '',
                                mappingType: 'sourceAttribute',
                                attributeType: 'text',
                                policyEnabled: false,
                                policy: '',
                                attributeValue: {
                                    sourcefield: '',
                                    value: ''
                                }
                            }
                        ],
                        targetDatabase: '',
                        targetDatabaseType: '',
                        targetTable: '',
                        operation: 'INSERT',
                        condition: '',
                        code: '',
                        attributes: [
                            {
                                attributeName: '',
                                isCalculatedField: false,
                                claculatedField: {
                                    fields: [],
                                    formula: ''
                                },
                                attributeValue: {
                                    type: '',
                                    method: '',
                                    value: ''
                                }
                            }
                        ],
                        batchStrategy: {
                            limit: 100,
                            limitBy: 'minute',
                            interval: 30,
                            migrateSample: false,
                            sampleSize: 5,
                            immediateFirstBatch: false,
                            retry: false,
                            createErrorBatchOnEmptyRecords: true,
                            createErrorBatchOnApiError: true
                        },
                    };
                    this.plan.target.push(obj);

                    this.targetName = name;
                    this.currentTargetName = name;
                    this.currentTargetIndex = this.Index;
                    this.currentTarget = obj;
                    this.Index = this.Index + 1;
                    this.apiSearchText = '';
                } else {
                    const msgText = 'Target';
                    this.platform.openSnackBar(msgText + ' named ' + name + ' already exists', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.addDataTarget();
                }

            }
        });
    }

    addDependentTarget(index) {
        const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
            width: '400px',
            data: {name: '', type: 'dependent target'}
        });
        dialogRef.afterClosed().subscribe(name => {
            if (name && name !== '' && name !== ' ') {
                const duplicatePlans = this.plan.target[index].dependentTargets.filter((v, i) => v.name === name);
                if (!duplicatePlans.length) {
                    const obj = {
                        name: name,
                        target_type: 'API',
                        targetProvider: {},
                        targetExecutor: {method: '', apiUrl: '', params: {}},
                        targetConnector: {},
                        process_type_into_target: 'json',
                        fieldMappings: [
                            {
                                targetfield: '',
                                mappingType: 'sourceAttribute',
                                attributeType: 'text',
                                policyEnabled: false,
                                policy: '',
                                attributeValue: {
                                    sourcefield: '',
                                    value: ''
                                }
                            }
                        ],
                        targetDatabase: '',
                        targetDatabaseType: '',
                        targetTable: '',
                        operation: 'INSERT',
                        condition: '',
                        code: '',
                        attributes: [
                            {
                                attributeName: '',
                                isCalculatedField: false,
                                claculatedField: {
                                    fields: [],
                                    formula: ''
                                },
                                attributeValue: {
                                    type: '',
                                    method: '',
                                    value: ''
                                }
                            }
                        ],
                        batchStrategy: {
                            limit: 100,
                            limitBy: 'minute',
                            interval: 30,
                            migrateSample: false,
                            sampleSize: 5,
                            immediateFirstBatch: false,
                            retry: false,
                            createErrorBatchOnEmptyRecords: true,
                            createErrorBatchOnApiError: true
                        },
                    };
                    this.plan.target[index].dependentTargets.push(obj);
                    this.apiSearchText = '';
                } else {
                    const msgText = 'Dependent Target';
                    this.platform.openSnackBar(msgText + ' named ' + name + ' already exists', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.addDependentTarget(index);
                }

            }
        });
    }

    setCurrentTarget(index) {
        this.currentTargetIndex = index;
        this.currentTargetName = this.plan.target[index].name;
        this.currentTarget = this.plan.target[index];
    }

    setCurrentSource(index) {
        this.currentSourceIndex = index;
        this.currentSourceName = this.plan.source[index].name;
        this.currentSource = this.plan.source[index];
    }

    setCurrentSourceExtender(index) {
        this.currentSourceExtenderIndex = index;
        this.currentSourceExtenderName = this.plan.sourceDataExtender[index].name;
        this.currentSourceExtender = this.plan.sourceDataExtender[index];
    }

    addDataSource() {
        const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
            width: '400px',
            data: {name: '', type: 'source'}
        });
        dialogRef.afterClosed().subscribe(name => {
            if (name && name !== '' && name !== ' ') {
                const duplicatePlans = this.plan.source.filter((v, i) => v.name === name);
                if (!duplicatePlans.length) {
                    const newSource = {
                        name: name,
                        source_type: 'API',
                        sourceProvider: {},
                        sourceExecutor: {method: '', apiUrl: '', params: {}, responseAttributes: []},
                        sourceConnector: {},
                        source_response_type: 'array<json>',
                        rootMapping: '',
                        sourceDatabase: '',
                        sourceDatabaseType: '',
                        sourceMethod: '',
                        sourceDatabaseObject: '',
                        tables: [],
                        code: '',
                        query_builder: {
                            fields: []
                        },
                        chunkStrategy: {
                            limit: 3,
                            totalRecords: 3,
                            paginationMethod: 'pagelimit',
                            paginationFields: {
                                offsetField: 'page',
                                limitField: 'row_count'
                            }
                        }
                    };

                    if (!Array.isArray(this.plan.source)) {
                        this.plan.source = [];
                    }

                    this.plan.source.push(newSource);
                    this.currentSourceName = name;
                    this.currentSourceIndex = this.sourceIndex;
                    this.currentSource = newSource;
                    this.apiSearchText = '';
                    this.sourceIndex = this.sourceIndex + 1;
                } else {
                    const msgText = 'Source';
                    this.platform.openSnackBar(msgText + ' named ' + name + ' already exists', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.addDataSource();
                }

            }
        });
    }

    addDataSourceExtender() {
        const dialogRef = this.dialog.open(TestCaseNameInputDialog, {
            width: '400px',
            data: {name: '', type: 'source extender'}
        });
        dialogRef.afterClosed().subscribe(name => {
            if (name && name !== '' && name !== ' ') {
                const duplicatePlans = this.plan.sourceDataExtender.filter((v, i) => v.name === name);
                if (!duplicatePlans.length) {
                    const newSource = {
                        name: name,
                        source_type: 'API',
                        sourceProvider: {},
                        sourceExecutor: {method: '', apiUrl: '', params: {}, responseAttributes: []},
                        sourceConnector: {},
                        source_response_type: 'array<json>',
                        rootMapping: '',
                        sourceDatabase: '',
                        sourceDatabaseType: '',
                        sourceMethod: '',
                        sourceDatabaseObject: '',
                        tables: [],
                        code: '',
                        query_builder: {
                            fields: []
                        },
                    };

                    if (!Array.isArray(this.plan.sourceDataExtender)) {
                        this.plan.sourceDataExtender = [];
                    }

                    this.plan.sourceDataExtender.push(newSource);
                    this.currentSourceExtenderName = name;
                    this.currentSourceExtenderIndex = this.sourceExtenderIndex;
                    this.currentSourceExtender = newSource;
                    this.sourceExtenderIndex = this.sourceExtenderIndex + 1;
                    this.apiSearchText = '';
                } else {
                    const msgText = 'Source Extender';
                    this.platform.openSnackBar(msgText + ' named ' + name + ' already exists', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.addDataSourceExtender();
                }

            }
        });
    }


    deleteSource(i) {
        const dialogRef = this.dialog.open(ConfirmTestcaseDeletionComponent, {
            width: '400px',
            data: {name: this.plan.source[i].name}
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'yes') {
                this.plan.source.splice(i, 1);
                this.currentSourceIndex = this.currentSourceIndex !== 0 ? this.currentSourceIndex - 1 : this.currentSourceIndex;
                this.currentSourceName = this.plan.source.length ? this.plan.source[this.currentSourceIndex].name : '';
                this.sourceIndex = this.sourceIndex !== 0 ? this.sourceIndex - 1 : this.sourceIndex;
            }
        });

    }

    deleteSourceExtender(i) {
        const dialogRef = this.dialog.open(ConfirmTestcaseDeletionComponent, {
            width: '400px',
            data: {name: this.plan.sourceDataExtender[i].name}
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'yes') {
                this.plan.sourceDataExtender.splice(i, 1);
                this.currentSourceExtenderIndex = this.currentSourceExtenderIndex !== 0 ? this.currentSourceExtenderIndex - 1 : this.currentSourceExtenderIndex;
                this.currentSourceExtenderName = this.plan.sourceDataExtender.length ? this.plan.sourceDataExtender[this.currentTargetIndex].name : '';
                this.sourceExtenderIndex = this.sourceExtenderIndex !== 0 ? this.sourceExtenderIndex - 1 : this.sourceExtenderIndex;
            }
        });

    }


    deleteTarget(i) {
        const dialogRef = this.dialog.open(ConfirmTestcaseDeletionComponent, {
            width: '400px',
            data: {name: this.plan.target[i].name}
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'yes') {
                this.plan.target.splice(i, 1);
                this.currentTargetIndex = this.currentTargetIndex !== 0 ? this.currentTargetIndex - 1 : this.currentTargetIndex;
                this.currentTargetName = this.plan.target.length ? this.plan.target[this.currentTargetIndex].name : '';
                this.Index = this.Index !== 0 ? this.Index - 1 : this.Index;
            }
        });

    }

    deleteDependentTarget(i, k) {
        const dialogRef = this.dialog.open(ConfirmTestcaseDeletionComponent, {
            width: '400px',
            data: {name: this.plan.target[i].dependentTargets[k].name}
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'yes') {
                this.plan.target[i].dependentTargets[k].splice(i, 1);
            }
        });

    }

    removeAttributeInPlan(data, index) {
        if (data.length === 1) {
            this.platform.openSnackBar('You need to have at least one target', 'Error', {
                duration: 4000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        } else {
            data.splice(index, 1);
        }

    }


    onMethodChange(method: string) {
        this.chunkStrategy.paginationMethod = method;
        const defaults = this.defaultFieldOptions[method];
        this.chunkStrategy.paginationFields.offsetField = defaults.offsetField;
        this.chunkStrategy.paginationFields.limitField = defaults.limitField;
    }

    addConnector(index) {
        const payload = {
            connector: this.plan.source[index].sourceProvider,
            connections: this.connections,
            connectorsID: this.connectorsID,
            redirect: false
        };
        const dialogRef = this.dialog.open(GetConnectorConfigurationsComponent, {
            data: payload,
            width: '400px'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.refreshConnectors(index);
        });
    }

    addTargetConnector(i) {
        const payload = {
            connector: this.plan.target[i].targetProvider,
            connections: this.targetConnectionsList[i],
            connectorsID: this.targetConnectorsIDList[i],
            redirect: false
        };
        const dialogRef = this.dialog.open(GetConnectorConfigurationsComponent, {
            data: payload,
            width: '400px'
        });

        dialogRef.afterClosed().subscribe(result => {
            this.refreshTargetConnectors(i);
        });
    }

    getApiProviders(provider) {
        if (this.editFlag || this.viewPlan) {
            return [provider];
        } else {
            return this.apiProviders;
        }
        return [];
    }

    getExecutors(executors) {
        if (this.editFlag || this.viewPlan) {
            return [executors];
        } else {
            return this.executors;
        }
        return [];
    }

    getTargetExecutors(executors, i) {
        if (this.editFlag || this.viewPlan) {
            return [executors];
        } else {
            return this.targetExecutorsList[i];
        }
        return [];
    }

    getConnections(connections) {
        if (this.editFlag || this.viewPlan) {
            return [connections];
        } else {
            return this.connections;
        }
        return [];
    }

    getTargetConnections(connections, i) {
        if (this.editFlag || this.viewPlan) {
            return [connections];
        } else {
            return this.targetConnectionsList[i];
        }
        return [];
    }

    async getServiceProviderApi(index) {
        // console.log(this.plan.source.sourceProvider);
        if (this.plan.source[index].sourceProvider.producer) {
            this.flag = true;
            this.executors = [];
            this.arrayList = [];
            this.connections = [];
            this.b2bServiceProviders(index).then(() => {
                if (localStorage.getItem('partner') !== 'b2b') {
                    this.flag = true;
                    this.nonb2bServiceProviders(index);
                }
            });
            this.refreshConnectors(index);
        }
    }

    b2bServiceProviders(index) {
        return new Promise((resolve, reject) => {
            this.confPost.getPartnerAccountServiceProviderCategorybyGroup('b2b', 'b2b', this.plan.source[index].sourceProvider.producer).subscribe(result => {
                this.flag = false;
                const iterator = result[Symbol.iterator]();
                while (true) {
                    const tempObject = iterator.next();
                    if (tempObject.done) {
                        break;
                    }
                    this.arrayList.push(tempObject.value);
                }
                if (this.arrayList !== null && this.arrayList.length > 0) {
                    this.selected_executor = this.arrayList[0]['executors'][0];
                }
                resolve('success');
            }, error => {
                this.flag = false;
                resolve('failed');
            });
        });
    }

    nonb2bServiceProviders(index) {
        return new Promise((resolve, reject) => {
            if (this.plan.source[index].sourceProvider.producer === 'apiplatform') {
                this.confPost.getApiExecutorsForPartnerAccount(localStorage.getItem('partner'), localStorage.getItem('account')).subscribe(result => {
                    this.flag = false;
                    const iterator = result[Symbol.iterator]();
                    while (true) {
                        const tempObject = iterator.next();
                        if (tempObject.done) {
                            break;
                        }
                        this.arrayList.push(tempObject.value);
                    }
                    // console.log(this.arrayList);
                    if (this.arrayList !== null && this.arrayList.length > 0) {
                        this.executors = [];
                        for (let item of this.arrayList) {
                            for (let exe of item.executors) {
                                this.executors.push(exe);
                            }
                        }
                        for (let i = 0; i < this.executors.length; i++) {
                            this.executors[i].account = this.executors[i].account_id;
                            delete this.executors[i].account_id;
                        }
                        // console.log(this.executors);
                        this.selected_executor = this.arrayList[0]['executors'][0];


                    }
                    resolve('success');
                }, error => {
                    this.flag = false;
                    resolve('failed');
                });
            } else {
                this.confPost.getPartnerAccountServiceProviderCategorybyGroup(localStorage.getItem('partner'), localStorage.getItem('account'), this.plan.source[index].sourceProvider.producer).subscribe(result => {
                    this.flag = false;
                    const iterator = result[Symbol.iterator]();
                    while (true) {
                        const tempObject = iterator.next();
                        if (tempObject.done) {
                            break;
                        }
                        this.arrayList.push(tempObject.value);
                    }
                    // console.log(this.arrayList);
                    if (this.arrayList !== null && this.arrayList.length > 0) {
                        this.executors = [];
                        for (let item of this.arrayList) {
                            for (let exe of item.executors) {
                                this.executors.push(exe);
                            }
                        }
                        for (let i = 0; i < this.executors.length; i++) {
                            this.executors[i].account = this.executors[i].account_id;
                            delete this.executors[i].account_id;
                        }
                        // console.log(this.executors);
                        this.selected_executor = this.arrayList[0]['executors'][0];


                    }
                    resolve('success');
                }, error => {
                    this.flag = false;
                    resolve('failed');
                });
            }

        });
    }

    refreshConnectors(index) {
        this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&producer=' + this.plan.source[index].sourceProvider.producer).subscribe((response: any) => {
            if (response && response.length > 0) {
                this.connections = response[0]['connectors'];
                if (this.connections && this.connections.length > 0) {
                    this.plan.source[index].sourceConnector = this.connections[0];
                }
                this.connectorsID = response[0]['id'];
                // console.log(this.connections);
            }
        });
    }

    async getTargetServiceProviderApi(i) {
        // console.log(this.plan.target[i].targetProvider);
        if (this.plan.target[i].targetProvider.producer) {
            this.target_flag = true;

            this.b2bServiceTargetProviders(i).then(() => {
                if (localStorage.getItem('partner') !== 'b2b') {
                    this.target_flag = true;

                    this.nonb2bServiceTargetProviders(i);
                }
            });
            this.refreshTargetConnectors(i);
        }
    }

    b2bServiceTargetProviders(i) {
        return new Promise((resolve, reject) => {
            this.confPost.getPartnerAccountServiceProviderCategorybyGroup('b2b', 'b2b', this.plan.target[i].targetProvider.producer).subscribe(result => {
                this.target_flag = false;
                this.targetArrayList = [];
                const iterator = result[Symbol.iterator]();
                while (true) {
                    const tempObject = iterator.next();
                    if (tempObject.done) {
                        break;
                    }
                    this.targetArrayList.push(tempObject.value);
                }
                if (this.targetArrayList !== null && this.targetArrayList.length > 0) {
                    this.target_selected_executor = this.targetArrayList[0]['executors'][0];
                }
                resolve('success');
            }, error => {
                this.target_flag = false;

                resolve('failed');
            });
        });
    }

    nonb2bServiceTargetProviders(i) {
        return new Promise((resolve, reject) => {
            this.confPost.getPartnerAccountServiceProviderCategorybyGroup(localStorage.getItem('partner'), localStorage.getItem('account'), this.plan.target[i].targetProvider.producer).subscribe(result => {
                this.target_flag = false;

                const iterator = result[Symbol.iterator]();
                while (true) {
                    const tempObject = iterator.next();
                    if (tempObject.done) {
                        break;
                    }
                    this.targetArrayList.push(tempObject.value);
                }
                // console.log(this.targetArrayList);
                if (this.targetArrayList !== null && this.targetArrayList.length > 0) {
                    this.targetExecutors = [];
                    for (let item of this.targetArrayList) {
                        for (let exe of item.executors) {
                            this.targetExecutors.push(exe);
                        }
                    }
                    for (let i = 0; i < this.targetExecutors.length; i++) {
                        this.targetExecutors[i].account = this.targetExecutors[i].account_id;
                        delete this.targetExecutors[i].account_id;
                    }
                    if (this.targetExecutorsList.length === 0) {
                        this.targetExecutorsList.push(this.targetExecutors);
                    } else {
                        this.targetExecutorsList[i] = this.targetExecutors;
                    }
                    this.target_selected_executor = this.targetArrayList[0]['executors'][0];
                }
                resolve('success');
            }, error => {
                this.target_flag = false;

                resolve('failed');
            });
        });
    }

    refreshTargetConnectors(i) {
        this.confPost.getData('services', 'services', 'v1', 'apiconnectors', 'partner=' + localStorage.getItem('partner') + '&account=' + localStorage.getItem('account') + '&producer=' + this.plan.target[i].targetProvider.producer).subscribe((response: any) => {
            if (response && response.length > 0) {
                this.targetConnections = response[0]['connectors'];
                this.targetConnectorsID = response[0]['id'];
                // console.log(this.targetConnections);

                if (this.targetConnectionsList.length == 0) {
                    this.targetConnectionsList.push(this.targetConnections);
                } else {
                    this.targetConnectionsList[i] = this.targetConnections;
                }

                if (this.targetConnectorsIDList.length == 0) {
                    this.targetConnectorsIDList.push(this.targetConnectorsID);
                } else {
                    this.targetConnectorsIDList[i] = this.targetConnectorsID;
                }
                // console.log(this.targetConnectorsIDList);
            } else {
                this.targetConnectionsList.push([]);
                this.targetConnectorsIDList.push([]);
            }
        });
    }

    displayFn(option: any): string {
        return option && option.executor_version && option.executor_name ? option.executor_version + ' ' + option.executor_name : '';
    }

    omit_special_char(event) {
        const charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123) || charCode === 8 || charCode === 32 || (charCode >= 48 && charCode <= 57)) {
            event.preventDefault();
            return false;
        } else {
            return true;
        }
    }

    addResponseAttribute() {
        const dialogRef = this.dialog.open(AddAttributeComponent, {
            minHeight: '45vh',
            maxHeight: '75vh',
        });
        dialogRef.afterClosed().subscribe(res => {
            if (res && res !== undefined && res !== null) {
                let temp = res;
                if (this.plan.source.sourceExecutor.responseAttributes && this.plan.source.sourceExecutor.responseAttributes !== null && this.plan.source.sourceExecutor.responseAttributes !== undefined) {
                    this.plan.source.sourceExecutor['responseAttributes'].push(temp);
                } else {
                    this.plan.source.sourceExecutor['responseAttributes'] = [];
                    this.plan.source.sourceExecutor['responseAttributes'].push(temp);
                }
            }
        });
    }

    assignRootMaaping(value, index) {
        this.plan.source[index].rootMapping = value;
    }

    assignSourceResponseType(value, index) {
        this.plan.source[index].source_response_type = value;
    }

    getSourceResponseAttributesList1(data, prefix = '', attributes = []) {
        if (Array.isArray(data)) {
            data.forEach(item => {
                const attributeName = prefix ? `${prefix}.${item.attributeName}` : item.attributeName;
                if (attributeName) {
                    attributes.push(attributeName);
                }
                if (item.subType && item.subType.length > 0) {
                    this.getSourceResponseAttributesList1(item.subType, attributeName, attributes);
                }
            });
        }
        return attributes;
    }

    getSourceResponseParams(list) {
        if (this.plan.source[0].source_type === 'CSV') {
            return this.csvHeaders;
        } else {
            if (this.plan.source[0].rootMapping === '') {
                return list;
            } else {
                const params = [];
                const rootMapName = this.plan.source[0].rootMapping + '.';
                for (let i = 0; i < list.length; i++) {
                    if (list[i].startsWith(rootMapName)) {
                        const parts = list[i].split('.');
                        if (parts.length > 1) {
                            params.push(parts.slice(1).join('.'));
                        }
                    }
                }
                return params;
            }
        }
    }


    getSourceResponseAttributesList(attributes) {
        let temp: any = [];
        temp = this.getSourceResponseAttributesList1(attributes);
        return temp;
    }

    assignTargetAttributs(i) {
        // this.plan.target[i].targetFields = this.plan.target[i].targetExecutor.responseAttributes;
        this.getPolicyBuilderAttributes(i);
    }

    getRootMaaping(index) {
        if (this.plan.source[index].sourceExecutor.responseAttributes && this.plan.source[index].sourceExecutor.responseAttributes.length > 0) {
            this.sourceResponseAttributes = this.getSourceResponseAttributesList1(this.plan.source[index].sourceExecutor.responseAttributes);
        }
    }

    getDataBaseType() {
        if (this.plan.source.sourceDatabase) {
            for (const item of this.dbs) {
                if (item.database_name === this.plan.source.sourceDatabase) {
                    this.plan.source.sourceDatabaseType = item.database_type;
                }
            }
        }
    }

    getTargetDataBaseType(index) {
        if (this.plan.target[index].targetDatabase) {
            for (const item of this.dbs) {
                if (item.database_name === this.plan.target[index].targetDatabase) {
                    this.plan.target[index].targetDatabaseType = item.database_type;
                }
            }
        }
    }

    checkExistingTargetTable(index) {
        if (this.plan.target[index].targetTable && this.plan.target[index].targetTable !== '') {
            for (let i = 0; i < this.plan.target.length; i++) {
                if (i !== index && this.plan.target[index].targetDatabase === this.plan.target[i].targetDatabase &&
                    this.plan.target[index].targetTable === this.plan.target[i].targetTable) {
                    this.platform.openSnackBar('The table you selected already exist', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.plan.target[index].targetTable = '';
                }
            }

            for (let j = 0; j < this.plan.source.tables.length; j++) {
                if (this.plan.target[index].targetDatabase === this.plan.source.sourceDatabase &&
                    this.plan.target[index].targetTable === this.plan.source.tables[j]['entity']) {
                    this.platform.openSnackBar('The target table must not be the same as the source table.', 'Error', {
                        duration: 3000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.plan.target[index].targetTable = '';
                }
            }
        }
    }

    getDatabaseTablesWithAttributes(database_name) {
        for (const item of this.dbs) {
            if (item.database_name === database_name) {
                return item.accounts[0]['entities'];
            }
        }
        return [];
    }

    getDatabaseTables(database_name) {
        let temp = [];
        for (const item of this.dbs) {
            if (item.database_name === database_name) {
                for (const item1 of item.accounts[0]['entities']) {
                    temp.push(item1['entity']);
                }
            }
        }
        return temp;
    }

    getTableAttributes() {
        if (this.target_table) {
            this.targetAttributesList = [];
            for (const item of this.target_table.attributes) {
                this.targetAttributesList.push(item);
            }
        }
    }

    removeAttribute(data, index) {
        data.splice(index, 1);
    }

    getPolicyBuilderAttributes(index) {
        let fields: any = {};
        for (let attribute of this.plan['target'][index]['attributes']) {
            if (attribute.attributeName !== '') {
                let obj = {
                    name: this.plan['target'][index]['targetExecutor']['executor_name'] + '_' + attribute.attributeName,
                    type: 'string',
                    operators: ['=', '==', '!=', '<', '<=', '>', '>=']
                };
                fields[attribute.attributeName] = obj;
            }
        }

        // for(let attribute of this.getSourceResponseAttributesList1(this.plan.source.sourceExecutor.responseAttributes)) {
        //     let obj = {name: this.plan['target'][index]['targetExecutor']['executor_name']+'_'+attribute.attributeName, type: 'string', operators: ['=', '==', '!=', '<', '<=', '>', '>=']};
        //         fields[attribute.attributeName]=obj;
        // }
        // this.config2 = {fields: fields};
        // console.log(this.config2);
    }

    addPolicyToAttribute(attribute) {
        const dialogRef = this.dialog.open(DynamicFieldDialog, {
            width: '40vw',
            data: {
                type: 'condition',
                attribute: attribute,
                policyAttributes: this.getSourceResponseParams(this.getSourceResponseAttributesList1(this.plan.source[0].sourceExecutor.responseAttributes)),

            }
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                if (response['policy']) {
                    attribute.policy = response['policy'];
                }
            }
        });

    }


    addAttributeFieldToPlan(index) {
        this.plan['target'][index]['fieldMappings'].push({
            targetfield: '',
            mappingType: 'sourceAttribute',
            attributeType: 'text',
            policyEnabled: false,
            policy: '',
            sourcefield: '',
            value: '',
            query: '',
            attributeValue: {
                sourcefield: '',
                value: ''
            }
        });
        this.getPolicyBuilderAttributes(index);
    }

    assignTargetAttributeValueType(event, data, targetTable, targetDatabase) {
        const selectedAttribute = event.target.value;
        const selectedObject = this.getAttributesForTable(targetTable, targetDatabase).find(obj => obj.attributeName === selectedAttribute);
        data['attributeValue']['type'] = selectedObject ? selectedObject.type : 'String';
    }


    getAttributesForTable(tableName, dbname) {
        // if (this.listOfTableAttributes.hasOwnProperty(dbname + '=>' + tableName)) {
        //     return this.listOfTableAttributes[dbname + '=>' + tableName];
        // } else {
        //     return [];
        // }

        let temp = [];
        for (const item of this.dbs) {
            if (item.database_name === dbname) {
                for (const item1 of item.accounts[0]['entities']) {
                    if (item1['entity'] === tableName) {
                        for (const item2 of item1['attributes']) {
                            temp.push(item2);
                        }
                    }
                }
            }
        }
        return temp;
    }

    add() {
        const dbObj = {
            database_type: this.database['database_type'],
            database_name: this.database['database_name'],
            account_id: this.database['accounts'][0]['account_id'],
        };
        const obj = {entity: this.table, database: dbObj};
        if (this.tables.map(item => JSON.stringify(item)).indexOf(JSON.stringify(obj)) !== -1) {
            alert('table already exist.!');
        } else {
            // this.tables.push(obj);
            this.tables = [...this.tables, obj];
            // console.log(this.tables);
        }
    }

    deleteTable(i) {
        const dialogRef = this.dialog.open(ConfirmTestcaseDeletionComponent, {
            width: '400px',
            data: {name: this.plan.source.tables[i].entity}
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response && response === 'yes') {
                this.plan.source.tables.splice(i, 1);
                this.currentTableIndex = this.currentTableIndex !== 0 ? this.currentTableIndex - 1 : this.currentTableIndex;
                this.currentTableName = this.plan.source.tables.length ? this.plan.source.tables[this.currentTableIndex].entity : '';
                this.Index = this.Index !== 0 ? this.Index - 1 : this.Index;
            }
        });

    }

    setCurrentPlan(index) {
        this.currentTableIndex = index;
        this.currentTableName = this.plan.source.tables[index].entity.entity;
    }

    assignItem(query) {
        this.plan['source']['query_builder'] = query;
        this.emitResult();
    }

    bQTabChanged(event) {
        this.selectedBQTab = event.index;
    }

    emitResult() {
        this.plan['source']['type'] = this.selectedSource;
        this.plan['source']['method_type'] = this.method;
        this.plan['source']['code'] = this.code;
        this.plan['source']['dbDetails'] = this.tables;
        this.parentEvent.emit(this.plan);
    }

    download() {
        $('.actions-crud').find('a:eq(2)').find('angular2csv').find('button').click();
        this.saveAsProject();
    }

    saveAsProject() {
        if (this.responseData !== null && this.responseData !== undefined) {
            const data = this.responseData;
            const fileName = 'download';
            const exportType = 'json';
            exportFromJSON({data, fileName, exportType});
        }
    }

    getStatusCodeStyle(val) {
        if (val < 400) {
            return 'status-ok';
        } else {
            return 'status-not-ok';
        }
    }

    checkFilter() {
        if (this.filterData === null || this.filterData === undefined || this.filterData === []) {
            this.searchText = '';
            alert('Please select and attribute to filter.');
        }
    }

    typeOfval(val) {
        return typeof val;
    }

    stringifyjson(val) {
        if (val != null) {
            return JSON.stringify(val, null, 2).trim();
        } else {
            return val;
        }
    }

    executeSqlStatement(query) {
        // console.log(this.plan.source.sourceDatabase, this.plan.source.code);
        if (this.plan.source.sourceDatabase && this.plan.source.sourceDatabase !== undefined && this.plan.source.sourceDatabase !== null) {
            if (this.plan.source.sourceDatabase) {
                // if (this.plan.source.code !== null && this.plan.source.code !== undefined && this.plan.source.code !== '') {
                this.itemList = [];
                this.responseCode = '';
                this.responseData = '';
                this.errorMessage = '';
                this.responseError = '';
                this.confPost.getDatabaseForPartner(localStorage.getItem('partner'), localStorage.getItem('account'), this.plan.source.sourceDatabase).subscribe(db => {
                    const cursorPosition = this.editor.getEditor().getCursorPosition();
                    query = this.editor.getEditor().getSession().getLine(cursorPosition.row);
                    const executorModel = {
                        'database': {},
                        'query': query.trim().replace(/\n/g, ' '),
                        'paramPrefixSubString': ' :'
                    };
                    if (db.hasOwnProperty('database_name') && db.hasOwnProperty('database_type')) {
                        executorModel.database['database_name'] = db['database_name'];
                        executorModel.database['database_type'] = db['database_type'];
                    }
                    const payload = {
                        'executor_type': 'SQLQUERY',
                        'published': true,
                        'scopeOfAccess': 'public',
                        'creationTime': 1707826337360,
                        'lastModifiedTime': 1707826337360,
                        'registeredAsIs': false,
                        'queryParams': [],
                        'headers': [],
                        'mockResponses': [],
                        'authModel': {
                            'authType': '',
                            'authAttributes': {}
                        },
                        'source': 'select * from phone;',
                        'executors': [
                            {
                                'database': {
                                    'database_name': 'sqlserverdevvikramtest',
                                    'database_type': 'sqlserver'
                                },
                                'query': 'select * from phone;',
                                'paramPrefixSubString': ' :'
                            }
                        ],
                        'partner': 'dev-vikram',
                        'account_id': 'dev-vikram',
                        'apiUrl': 'https://dev-vikram.gateway.apiplatform.io/undefined/undefined',
                        'dataroot': null,
                        'attributeMappings': null,
                        'response': null,
                        'block_attributes': null,
                        'gatewaySettings': []
                    };
                    const startTime = performance.now();
                    this._service.executeApiV2(payload).subscribe(result => {
                            const endTime = performance.now();
                            this.responses = result.body;
                            this.responseItems = this.responses.body;
                            this.responseCode = this.responseItems.statusCode;
                            if (this.responseCode >= 400) {
                                this.error = true;
                            } else {
                                this.error = false;
                            }
                            if (this.responseItems.attributes !== null && this.responseItems.attributes !== undefined) {
                                for (let i = 0; i < this.responseItems.attributes.length; i++) {
                                    let tempObj = {};
                                    tempObj['id'] = i + 1;
                                    tempObj['itemName'] = this.responseItems.attributes[i]['attributeName'];
                                    this.itemList.push(tempObj);
                                }
                            }
                            if (this.error) {
                                if (this.responseItems.body) {
                                    this.erroResponse = JSON.parse(this.responseItems.body);
                                    this.errorMessage = 'Current SQL Statement: ' + query + ' => ' + this.erroResponse[0].message;
                                } else {
                                    this.errorMessage = 'Current SQL Statement: ' + query + ' => ' + this.responseItems.message;
                                    if (this.responseItems.error) {
                                        this.responseError = this.responseItems.error;
                                    }
                                }
                            } else {
                                if (this.responseItems.body) {
                                    this.responseData = JSON.parse(this.responseItems.body);
                                    for (const item of this.responseData) {
                                        this.columns = [];
                                        for (const itemval in item) {
                                            this.columns.push(itemval);
                                        }
                                    }
                                }
                            }
                            this.responseTime = Math.round(endTime - startTime);

                        },
                        error => {
                            let errorMessage = '';
                            if (error.error['message']) {
                                errorMessage = error.error.message;
                            } else {
                                errorMessage = error.error;
                            }
                            this.responseCode = 404;
                            if (error && error.error && error.error !== null && error.error !== undefined
                                && error.error.body && error.error.body !== undefined) {
                                this.errorMessage = error.error.body;
                            } else {
                                this.errorMessage = 'Error while executing query: ' + query + '. Please check the SQL Query and Database connection.';
                            }
                            this.responseError = 'SQL Error';
                            // }
                            this.error = true;

                        });


                }, error => {
                    this.platform.openSnackBar('The database you selected does not exist', 'Error', {
                        duration: 15000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                });
            }
        } else {
            this.platform.openSnackBar('Please select a valid database connection to execute the SQL statement', 'Error', {
                duration: 15000,
                verticalPosition: 'top',
                horizontalPosition: 'center'
            });
        }

    }

    openCalculatedFields(targetAttributes, sourceFields, index, type) {
        const dialogRef = this.dialog.open(CalculatedFieldDialog, {
            width: '350px',
            data: {
                targetAttributes: targetAttributes,
                sourceFields: sourceFields,
                index: index,
                type: type
            }
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response && response.result === 'ok') {
                targetAttributes[index].attributeValue.value = '';
            }
        });
    }

    openCalculatedFieldsApi(targetAttribute, index) {
        const dialogRef = this.dialog.open(CalculatedFieldDialog, {
            width: '40vw',
            data: {
                attribute: targetAttribute,
                policyAttributes: this.getSourceResponseParams(this.getSourceResponseAttributesList1(this.plan.source[0].sourceExecutor.responseAttributes)),
                isDt: true
            }
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                targetAttribute = response;
            }
        });
    }

    addDynamicFieldApi(attribute, index) {
        const dialogRef = this.dialog.open(DynamicFieldDialog, {
            width: '40vw',
            data: {
                mappingType: attribute.mappingType,
                value: attribute.value,
                attribute: attribute,
                policyAttributes: this.getSourceResponseParams(this.getSourceResponseAttributesList1(this.plan.source[0].sourceExecutor.responseAttributes)),

            }
        });
        dialogRef.afterClosed().subscribe(response => {
            if (response) {
                if (response['value']) {
                    attribute.value = response['value'];
                }
                if (response['query']) {
                    attribute.query = response['query'];
                }
                if (response['override']) {
                    attribute.override = response['override'];
                    if (attribute.override && attribute.override.length > 0) {
                        for (const item of attribute.override) {
                            if (attribute.attributeType == 'number') {
                                item.targetvalue = Number(item.targetvalue);
                            }
                        }
                    }
                }
                // console.log(attribute);
            }
        });
    }

    onFileDropped(file) {
        this.file['item'] = file[0];
        this.file['progress'] = 0;
    }

    fileBrowseHandler(file) {
        this.file['item'] = file[0];
        this.file['progress'] = 0;
        this.extractHeaders(this.file['item']);
    }

    deleteFile() {
        if (confirm('Are you sure you want to delete this file?')) {
            this.file = {};
            this.s3URL = undefined;
            this.plan.source.sourceExecutor.apiUrl = '';
        }
    }

    extractHeaders(selectedFile) {
        if (selectedFile) {
            const reader = new FileReader();
            reader.readAsText(selectedFile);
            reader.onload = () => {
                const csvData = reader.result as string;
                const firstLine = csvData.split('\n')[0];
                const headers = firstLine.split(',');
                this.csvHeaders = headers.map(header => header.trim());
                // console.log(this.csvHeaders);
            };
        }
    }

    uploadtoS3() {
        if (this.file && this.file.item) {
            this.fileUploadLoading = true;
            this.confPost.uploadToS3(this.file.item).subscribe(res => {
                this.fileUploadLoading = false;
                let temp: any = res;
                if (res) {
                    const originalUrl = temp['s3URL'];
                    const newDomain = 'https://s3.amazonaws.com/hari.apiplatform.io';
                    const domainRegex = /^https?:\/\/[^\/]+/;
                    const convertedUrl = originalUrl.replace(domainRegex, newDomain);
                    this.s3URL = convertedUrl;
                    this.plan.source.sourceExecutor.apiUrl = this.s3URL;
                    this.platform.openSnackBar('File uploaded to S3 successfully', 'Success', {
                        duration: 2000,
                        verticalPosition: 'top',
                        horizontalPosition: 'center'
                    });
                    this.selectedTab = 1;
                }
            }, err => {
                this.fileUploadLoading = false;
                this.platform.openSnackBar('Error while uploading File to S3.', 'Error', {
                    duration: 2000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
                // console.log(err);
            });
        }

    }


}

@Component({
    selector: 'app-create-calculated-field',
    templateUrl: 'create-calculated-field.html',
    styleUrls: ['create-calculated-field.css']
})
export class CalculatedFieldDialog implements OnInit {

    @Input() isDt = false;
    @Input() dataObj: any;


    config1: QueryBuilderConfig;
    config2: QueryBuilderConfig;
    types = [
        {
            ds: 'Dynamic',
            value: 'dynamic'
        },
        {
            ds: 'Static',
            value: 'static'
        }
    ];
    types2 = [
        {
            ds: 'String',
            value: 'text'
        },
        {
            ds: 'Number',
            value: 'number'
        }
    ];

    methods: any = [{value: 'js', displayValue: 'Javascript'}, {value: 'policy', displayValue: 'Policy Builder'}];

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<CalculatedFieldDialog>) {
        dialogRef.disableClose = true;
        this.config2 = {
            fields: {}
        };
        if (this.data.isDt) {
            this.isDt = true;
            this.dataObj = this.data.attribute;
            if (this.data.policyAttributes) {
                if (!this.dataObj.attributeValue.policies) {
                    this.dataObj.attributeValue.policies = [];
                    let obj = {
                        query: {
                            condition: 'and',
                            rules: []
                        },
                        valueType: 'text',
                        value: ''

                    };
                    this.dataObj.attributeValue.policies.push(obj);
                }
                let fields: any = {};
                for (let attribute of this.data.policyAttributes) {
                    let obj = {name: attribute, type: 'string', operators: ['=', '==', '!=', '<', '<=', '>', '>=']};
                    fields[attribute] = obj;
                }
                this.config2 = {fields: fields};

            }


        }
    }

    ngOnInit() {
    }

    addPolicy() {
        let obj = {
            query: {
                condition: 'and',
                rules: []
            },
            valueType: 'text',
            value: ''

        };
        this.dataObj.attributeValue.policies.push(obj);
    }

    removePolicy(i) {
        this.dataObj.attributeValue.policies.splice(i, 1);
    }

    close() {
        if (!this.isDt) {
            this.dialogRef.close({result: 'ok'});
        } else {
            this.dialogRef.close(this.dataObj);
        }

    }
}


@Component({
    selector: 'dynamic-field',
    templateUrl: 'dynamic-field.html',
    styleUrls: ['dynamic-field.css']
})
export class DynamicFieldDialog implements OnInit {

    mappingType = 'Dynamic';
    dialogTitle = 'Dynamic';
    value = '';
    config2: QueryBuilderConfig;
    query = {
        condition: 'and',
        rules: []
    };
    type = 'mapping';

    constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<DynamicFieldDialog>) {
        dialogRef.disableClose = true;
        if (this.data) {
            if (this.data['type']) {
                this.type = this.data['type'];
                if (this.data.attribute && this.data.attribute.policy) {
                    this.query = this.data.attribute.policy;
                }
                this.config2 = {
                    fields: {}
                };
                let fields: any = {};
                for (let attribute of this.data.policyAttributes) {
                    let obj = {name: attribute, type: 'string', operators: ['=', '==', '!=', '<', '<=', '>', '>=']};
                    fields[attribute] = obj;
                }
                this.config2 = {fields: fields};
            }
            this.mappingType = this.data.mappingType;
            this.value = this.data.value;
            if (this.mappingType == 'js') {
                this.dialogTitle = 'Javascript';
            } else if (this.mappingType == 'condition') {
                this.dialogTitle = 'Conditional Value';
                if (this.data.attribute && this.data.attribute.query) {
                    this.query = this.data.attribute.query;
                }
                this.config2 = {
                    fields: {}
                };
                let fields: any = {};
                for (let attribute of this.data.policyAttributes) {
                    let obj = {name: attribute, type: 'string', operators: ['=', '==', '!=', '<', '<=', '>', '>=']};
                    fields[attribute] = obj;
                }
                this.config2 = {fields: fields};

            } else if (this.mappingType == '') {
                this.dialogTitle = 'Override';
                this.data.attribute.override = [];
            }
        }
    }

    ngOnInit() {
    }

    addOverride(override: any) {
        if (override) {
            override.push({sourcevalue: '', targetvalue: undefined});
        } else {
            override = [];
            override.push({sourcevalue: '', targetvalue: undefined});
        }

    }

    removeOverride(data, index) {
        data.splice(index, 1);
    }

    save() {
        if (this.mappingType == 'js') {
            this.dialogRef.close({value: this.value});
        } else if (this.mappingType == 'condition') {
            this.dialogRef.close({value: this.value, query: this.query});
        } else if (this.mappingType == '') {
            this.dialogRef.close({override: this.data.attribute.override});
        }
    }

    addPolicy() {
        if (this.type == 'condition') {
            this.dialogRef.close({policy: this.query});
        }
    }

    close() {
        this.dialogRef.close();
    }
}
